const labels = {
  composition: 'ABO_COMPOSITION',
  constituents: 'ABO_CONSTITUENTS',
  additives: 'ABO_ADDITIVES',
}

export default labels
